import {
    createForm,
    deleteForm,
    deleteFormField,
    downloadFormDataToExcel,
    downloadFormDataToPDF,
    getFormAnswersBySubmissionId,
    getFormById,
    getFormSubmissions,
    getListForm,
    updateForm,
    updateFormData,
    updateFormField,
    updateFormStatus,
} from "../../api/forms";

const forms = {
    namespaced: true,
    state: {
        form: null,
        forms: [],
        totalCount: 0,
        submissions: [],
        totalPages: 0,
        currentPage: 1,
        pageSize: 10,
        loading: false,
        error: null,
        updateLoading: false,
        updateError: null,
    },
    mutations: {
        CREATE_FORM_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        CREATE_FORM_SUCCESS(state, form) {
            state.loading = false;
            state.form = form;
        },
        CREATE_FORM_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
        GET_LIST_FORM_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        GET_LIST_FORM_SUCCESS(state, forms) {
            state.loading = false;
            state.forms = forms;
        },
        GET_LIST_FORM_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
        GET_FORM_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        GET_FORM_SUCCESS(state, form) {
            state.loading = false;
            state.form = form;
        },
        GET_FORM_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
        UPDATE_FORM_REQUEST(state) {
            state.updateLoading = true;
            state.updateError = null;
        },
        UPDATE_FORM_SUCCESS(state, updatedForm) {
            state.updateLoading = false;
            state.form = updatedForm.form;
            state.formFields = updatedForm.updatedFormFields;
        },
        UPDATE_FORM_FAILURE(state, error) {
            state.updateLoading = false;
            state.updateError = error;
        },
        UPDATE_FORM_FIELD_REQUEST(state) {
            state.updateLoading = true;
            state.updateError = null;
        },
        UPDATE_FORM_FIELD_SUCCESS(state, updatedField) {
            state.updateLoading = false;
            if (state.form && state.form.fields) {
                const index = state.form.fields.findIndex((field) => field._id === updatedField._id);
                if (index !== -1) {
                    state.form.fields.splice(index, 1, updatedField);
                }
            }
        },
        UPDATE_FORM_FIELD_FAILURE(state, error) {
            state.updateLoading = false;
            state.updateError = error;
        },
        DELETE_FORM_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        DELETE_FORM_SUCCESS(state, formId) {
            state.loading = false;
            state.forms = state.forms.filter((form) => form._id !== formId);
        },
        DELETE_FORM_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
        DELETE_FORM_FIELD_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        DELETE_FORM_FIELD_SUCCESS(state, fieldId) {
            state.loading = false;
            if (state.form && state.form.fields) {
                state.form.fields = state.form.fields.filter((field) => field._id !== fieldId);
            }
        },
        DELETE_FORM_FIELD_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
        GET_FORM_ANSWERS_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        GET_FORM_ANSWERS_SUCCESS(state, { submissions, totalPages, currentPage }) {
            state.loading = false;
            state.submissions = submissions;
            state.totalPages = totalPages;
            state.currentPage = currentPage;
        },
        GET_FORM_ANSWERS_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
        UPDATE_FORM_DATA_REQUEST(state) {
            state.updateLoading = true;
            state.updateError = null;
        },
        UPDATE_FORM_DATA_SUCCESS(state, updatedForm) {
            state.updateLoading = false;
            state.form = updatedForm;
        },
        UPDATE_FORM_DATA_FAILURE(state, error) {
            state.updateLoading = false;
            state.updateError = error;
        },
        SET_PAGE_SIZE(state, pageSize) {
            state.pageSize = pageSize;
        },
        SET_CURRENT_PAGE(state, page) {
            state.currentPage = page;
        },
        SET_FORM_TOTAL_COUNT(state, totalCount) {
            state.totalCount = totalCount;
        },
        DOWNLOAD_FORM_DATA_REQUEST(state) {
            state.loading = true;
            state.error = null;
        },
        DOWNLOAD_FORM_DATA_SUCCESS(state) {
            state.loading = false;
        },
        DOWNLOAD_FORM_DATA_FAILURE(state, error) {
            state.loading = false;
            state.error = error;
        },
    },
    actions: {
        async createForm({ commit, state }, form) {
            commit("CREATE_FORM_REQUEST");
            try {
                const { data } = await createForm(form.siteId, form.title, form.fields);
                commit("SET_FORM_TOTAL_COUNT", state.totalCount + 1);
                commit("CREATE_FORM_SUCCESS", data);
                return data;
            } catch (error) {
                commit("CREATE_FORM_FAILURE", error);
                throw error;
            }
        },
        async getListForm({ commit }, siteId) {
            commit("GET_LIST_FORM_REQUEST");
            try {
                const { data } = await getListForm();
                const { forms, totalCount } = data;
                commit("GET_LIST_FORM_SUCCESS", forms);
                commit("SET_FORM_TOTAL_COUNT", totalCount);
                return data;
            } catch (error) {
                commit("GET_LIST_FORM_FAILURE", error);
                throw error;
            }
        },
         async syncForms({ commit }) {
            commit("GET_LIST_FORM_REQUEST");
            try {
                const { data } = await getListForm();
                const { forms, totalCount } = data;
                commit("GET_LIST_FORM_SUCCESS", forms);
                commit("SET_FORM_TOTAL_COUNT", totalCount);
                return data;
            } catch (error) {
                commit("GET_LIST_FORM_FAILURE", error);
                throw error;
            }
        },
        async getFormById({ commit }, { siteId, formId }) {
            commit("GET_FORM_REQUEST");
            try {
                const { data } = await getFormById(formId);
                commit("GET_FORM_SUCCESS", data);
                return data;
            } catch (error) {
                commit("GET_FORM_FAILURE", error);
                throw error;
            }
        },
        async updateForm({ commit }, { siteId, formId, formData, formFieldsData }) {
            commit("UPDATE_FORM_REQUEST");
            try {
                for (const fieldData of formFieldsData) {
                    if (!fieldData.type || !fieldData.label || fieldData.order == null) {
                        throw new Error("FormField validation failed: type, label, and order are required.");
                    }
                }
                const { data } = await updateForm(siteId, formId, formData, formFieldsData);
                commit("UPDATE_FORM_SUCCESS", data);
                return data;
            } catch (error) {
                commit("UPDATE_FORM_FAILURE", error);
                throw error;
            }
        },
        async updateFormField({ commit }, { siteId, formFieldId, updateFields }) {
            commit("UPDATE_FORM_FIELD_REQUEST");
            try {
                const { data } = await updateFormField(siteId, formFieldId, updateFields);
                commit("UPDATE_FORM_FIELD_SUCCESS", data);
                return data;
            } catch (error) {
                commit("UPDATE_FORM_FIELD_FAILURE", error);
                throw error;
            }
        },
        async updateFormStatus({ commit }, { siteId, submissionId, newStatus }) {
            commit("UPDATE_FORM_REQUEST");
            try {
                const { data } = await updateFormStatus(siteId, submissionId, newStatus);
                commit("UPDATE_FORM_SUCCESS", data);
                return data;
            } catch (error) {
                commit("UPDATE_FORM_FAILURE", error);
                throw error;
            }
        },
        async deleteForm({ commit, state }, { siteId, formId }) {
            commit("DELETE_FORM_REQUEST");
            try {
                await deleteForm(siteId, formId);
                commit("DELETE_FORM_SUCCESS", formId);
                commit("SET_FORM_TOTAL_COUNT", state.totalCount - 1);
            } catch (error) {
                commit("DELETE_FORM_FAILURE", error);
                throw error;
            }
        },
        async deleteFormField({ commit }, { siteId, fieldId }) {
            commit("DELETE_FORM_FIELD_REQUEST");
            try {
                await deleteFormField(siteId, fieldId);
                commit("DELETE_FORM_FIELD_SUCCESS", fieldId);
            } catch (error) {
                commit("DELETE_FORM_FIELD_FAILURE", error);
                throw error;
            }
        },
        async getFormSubmissions({ commit, state }, { siteId, formId, status = "notRead", page = 1, perPage }) {
            commit("GET_FORM_ANSWERS_REQUEST");
            try {
                perPage = perPage || state.perPage || 10;
                const { data } = await getFormSubmissions(siteId, formId, status, page, perPage);
                commit("GET_FORM_ANSWERS_SUCCESS", {
                    submissions: data.submissions,
                    totalPages: data.totalPages,
                    currentPage: page,
                });
                return data;
            } catch (error) {
                commit("GET_FORM_ANSWERS_FAILURE", error);
                throw error;
            }
        },
        async updateFormData({ commit }, { siteId, formId, formData }) {
            commit("UPDATE_FORM_DATA_REQUEST");
            try {
                const { data } = await updateFormData(siteId, formId, formData);
                commit("UPDATE_FORM_DATA_SUCCESS", data);
                return data;
            } catch (error) {
                commit("UPDATE_FORM_DATA_FAILURE", error);
                throw error;
            }
        },
        async getFormAnswersBySubmissionId({ commit }, { siteId, submissionId }) {
            commit("GET_FORM_ANSWERS_REQUEST");
            try {
                const { data } = await getFormAnswersBySubmissionId(siteId, submissionId);
                commit("GET_FORM_ANSWERS_SUCCESS", data);
                return data;
            } catch (error) {
                commit("GET_FORM_ANSWERS_FAILURE", error);
                throw error;
            }
        },
        setPageSize({ commit }, pageSize) {
            commit("SET_PAGE_SIZE", pageSize);
        },
        setCurrentPage({ commit }, page) {
            commit("SET_CURRENT_PAGE", page);
        },
        async downloadFormDataToPDF({ commit }, { siteId, formId, submissionId = null }) {
            commit("DOWNLOAD_FORM_DATA_REQUEST");
            try {
                const response = await downloadFormDataToPDF(siteId, formId, submissionId);

                console.log("Response:", response);
                console.log("Response data:", response.data);

                const { downloadUrl } = response.data;

                console.log("downloadUrl:", downloadUrl);

                commit("DOWNLOAD_FORM_DATA_SUCCESS");

                return downloadUrl;
            } catch (error) {
                console.error("PDF indirme hatası:", error);
                commit("DOWNLOAD_FORM_DATA_FAILURE", error);
                throw error;
            }
        },
        async downloadFormDataToExcel({ commit }, { siteId, formId, submissionId = null }) {
            commit("DOWNLOAD_FORM_DATA_REQUEST");
            try {
                const response = await downloadFormDataToExcel(siteId, formId, submissionId);

                console.log("Response:", response);
                console.log("Response data:", response.data);

                const { downloadUrl } = response.data;

                console.log("downloadUrl:", downloadUrl);

                commit("DOWNLOAD_FORM_DATA_SUCCESS");

                return downloadUrl;
            } catch (error) {
                console.error("Excel indirme hatası:", error);
                commit("DOWNLOAD_FORM_DATA_FAILURE", error);
                throw error;
            }
        },
    },
    getters: {
        form: (state) => state.form,
        forms: (state) => state.forms,
        submissions: (state) => state.submissions,
        totalPages: (state) => state.totalPages,
        currentPage: (state) => state.currentPage,
        pageSize: (state) => state.pageSize,
        loading: (state) => state.loading,
        error: (state) => state.error,
        updateLoading: (state) => state.updateLoading,
        updateError: (state) => state.updateError,
    },
};

export default forms;
